import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared/shared.module';

// Human Resources Components
import { PermissionsComponent } from './permissions/permissions.component';
import { PermissionsDetailComponent } from './permissions/permissions-detail/permissions-detail.component';
import { MemosComponent } from './memos/memos.component';
import { MemosDetailComponent } from './memos/memos-detail/memos-detail.component';
import { DisabilitiesComponent } from './disabilities/disabilities.component';
import { DisabilitiesDetailComponent } from './disabilities/disabilities-detail/disabilities-detail.component';
import { UserEntryRecordComponent } from './user-entry-record/user-entry-record.component';
import { UserEntryRecordDetailComponent } from './user-entry-record/user-entry-record-detail/user-entry-record-detail.component';

const HumanResourcesComponents = [
  PermissionsComponent,
  PermissionsDetailComponent,
  MemosComponent,
  MemosDetailComponent,
  DisabilitiesComponent,
  DisabilitiesDetailComponent,
  UserEntryRecordComponent,
  UserEntryRecordDetailComponent
];

@NgModule({
  declarations: HumanResourcesComponents,
  imports: [SharedModule],
  exports: HumanResourcesComponents
})
export class HumanResourcesModule { }
